import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { Typography } from '@mui/material';

export default function EmpLangNewEditForm({ langarr }) {
  const { control, setValue, watch, resetField } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'empLang',
  });

  const langResarr = ['Basic', 'Intermediate', 'Fluent'];
  const handleAdd = () => {
    append({
      langSrno: 0,
      lang: null,
      read: null,
      write: null,
      speak: null,
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <>
      <Box
        mt={4}
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        <Box>
          <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
            Language Details:
          </Typography>
        </Box>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add Language
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={3}>
        {fields.map((item, index) => (
          <Stack key={item.id} alignItems="flex-end" spacing={1.5}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ width: 1 }}>
              <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <RHFTextField name={`empLang[${index}].langSrno`} />
              </Box>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empLang[${index}].lang`}
                  placeholder="Select language"
                  label={
                    <div>
                      Language<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={langarr}
                  showPlusIcon
                  getOptionLabel={(option) => option.languagesName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.languagesName}
                    </li>
                  )}
                  sx={{
                    minWidth: { md: 170 },
                  }}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empLang[${index}].read`}
                  placeholder="Select Proficiency"
                  label={
                    <div>
                      Read<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={langResarr}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option.name 
                  }
                  onChange={(_, newValue) =>
                    setValue(`empLang[${index}].read`, newValue ?? null, {
                      shouldValidate: true,
                    })
                  }
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                  sx={{
                    minWidth: { md: 170 },
                  }}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empLang[${index}].write`}
                  placeholder="Select Proficiency"
                  label={
                    <div>
                      Write<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={langResarr}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option.name 
                  }
                  onChange={(_, newValue) =>
                    setValue(`empLang[${index}].write`, newValue ?? null, {
                      shouldValidate: true,
                    })
                  }
                  renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                  sx={{
                    minWidth: { md: 170 },
                  }}
                />
              </Stack>
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empLang[${index}].speak`}
                  placeholder="Select Proficiency"
                  label={
                    <div>
                      Speak<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={langResarr}
                  getOptionLabel={(option) =>
                    typeof option === 'string' ? option : option.name 
                  }
                  onChange={(_, newValue) =>
                    setValue(`empLang[${index}].speak`, newValue ?? null, {
                      shouldValidate: true,
                    })
                  }
                    renderOption={(props, option) => (
                    <li {...props} key={option}>
                      {option}
                    </li>
                  )}
                  sx={{
                    minWidth: { md: 170 },
                  }}
                />
              </Stack>
              <Button
                sx={{ mt: -1.5 }}
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
EmpLangNewEditForm.propTypes = {
  langarr: PropTypes.array,
};
